var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.open)?_c('section',{staticClass:"ebx-discovery-wall"},[(_vm.renderDiscoveryWallBlocks)?[_vm._l((_vm.discoverWallBlocks),function(ref){
var blockName = ref[0];
var blockConfig = ref[1];
return [_vm._t("default",[_c('DiscoveryWallBlock',{key:blockName,attrs:{"blockConfig":blockConfig,"blockName":blockName}})],null,{blockName: blockName, blockConfig: blockConfig})]})]:_vm._t(_vm.$x.slots.discoveryWall.recommendationsFallback)],2):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }